import { defineComponent as A, ref as S, computed as p, provide as M, onMounted as N, watch as H, watchEffect as K, h as G, Fragment as J, onUnmounted as W, inject as j } from "vue";
import { useId as q } from "./index327.js";
import { useResolveButtonType as Q } from "./index329.js";
import { FocusSentinel as V } from "./index359.js";
import { Hidden as X } from "./index332.js";
import { Keys as T } from "./index334.js";
import { dom as d } from "./index339.js";
import { sortByDomNode as k, FocusResult as F, focusIn as E, Focus as g } from "./index340.js";
import { match as L } from "./index342.js";
import { microTask as Y } from "./index356.js";
import { getOwnerDocument as Z } from "./index343.js";
import { render as B, omit as _, Features as U } from "./index345.js";
var ee = ((e) => (e[e.Forwards = 0] = "Forwards", e[e.Backwards = 1] = "Backwards", e))(ee || {}), te = ((e) => (e[e.Less = -1] = "Less", e[e.Equal = 0] = "Equal", e[e.Greater = 1] = "Greater", e))(te || {});
let z = Symbol("TabsContext");
function D(e) {
  let c = j(z, null);
  if (c === null) {
    let f = new Error(`<${e} /> is missing a parent <TabGroup /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(f, D), f;
  }
  return c;
}
let C = Symbol("TabsSSRContext"), fe = A({ name: "TabGroup", emits: { change: (e) => !0 }, props: { as: { type: [Object, String], default: "template" }, selectedIndex: { type: [Number], default: null }, defaultIndex: { type: [Number], default: 0 }, vertical: { type: [Boolean], default: !1 }, manual: { type: [Boolean], default: !1 } }, inheritAttrs: !1, setup(e, { slots: c, attrs: f, emit: y }) {
  var b;
  let s = S((b = e.selectedIndex) != null ? b : e.defaultIndex), l = S([]), n = S([]), m = p(() => e.selectedIndex !== null), w = p(() => m.value ? e.selectedIndex : s.value);
  function h(a) {
    var r;
    let o = k(u.tabs.value, d), t = k(u.panels.value, d), i = o.filter((x) => {
      var I;
      return !((I = d(x)) != null && I.hasAttribute("disabled"));
    });
    if (a < 0 || a > o.length - 1) {
      let x = L(s.value === null ? 0 : Math.sign(a - s.value), { [-1]: () => 1, 0: () => L(Math.sign(a), { [-1]: () => 0, 0: () => 0, 1: () => 1 }), 1: () => 0 }), I = L(x, { 0: () => o.indexOf(i[0]), 1: () => o.indexOf(i[i.length - 1]) });
      I !== -1 && (s.value = I), u.tabs.value = o, u.panels.value = t;
    } else {
      let x = o.slice(0, a), I = [...o.slice(a), ...x].find((R) => i.includes(R));
      if (!I) return;
      let P = (r = o.indexOf(I)) != null ? r : u.selectedIndex.value;
      P === -1 && (P = u.selectedIndex.value), s.value = P, u.tabs.value = o, u.panels.value = t;
    }
  }
  let u = { selectedIndex: p(() => {
    var a, r;
    return (r = (a = s.value) != null ? a : e.defaultIndex) != null ? r : null;
  }), orientation: p(() => e.vertical ? "vertical" : "horizontal"), activation: p(() => e.manual ? "manual" : "auto"), tabs: l, panels: n, setSelectedIndex(a) {
    w.value !== a && y("change", a), m.value || h(a);
  }, registerTab(a) {
    var r;
    if (l.value.includes(a)) return;
    let o = l.value[s.value];
    if (l.value.push(a), l.value = k(l.value, d), !m.value) {
      let t = (r = l.value.indexOf(o)) != null ? r : s.value;
      t !== -1 && (s.value = t);
    }
  }, unregisterTab(a) {
    let r = l.value.indexOf(a);
    r !== -1 && l.value.splice(r, 1);
  }, registerPanel(a) {
    n.value.includes(a) || (n.value.push(a), n.value = k(n.value, d));
  }, unregisterPanel(a) {
    let r = n.value.indexOf(a);
    r !== -1 && n.value.splice(r, 1);
  } };
  M(z, u);
  let v = S({ tabs: [], panels: [] }), O = S(!1);
  N(() => {
    O.value = !0;
  }), M(C, p(() => O.value ? null : v.value));
  let $ = p(() => e.selectedIndex);
  return N(() => {
    H([$], () => {
      var a;
      return h((a = e.selectedIndex) != null ? a : e.defaultIndex);
    }, { immediate: !0 });
  }), K(() => {
    if (!m.value || w.value == null || u.tabs.value.length <= 0) return;
    let a = k(u.tabs.value, d);
    a.some((r, o) => d(u.tabs.value[o]) !== d(r)) && u.setSelectedIndex(a.findIndex((r) => d(r) === d(u.tabs.value[w.value])));
  }), () => {
    let a = { selectedIndex: s.value };
    return G(J, [l.value.length <= 0 && G(V, { onFocus: () => {
      for (let r of l.value) {
        let o = d(r);
        if (o?.tabIndex === 0) return o.focus(), !0;
      }
      return !1;
    } }), B({ theirProps: { ...f, ..._(e, ["selectedIndex", "defaultIndex", "manual", "vertical", "onChange"]) }, ourProps: {}, slot: a, slots: c, attrs: f, name: "TabGroup" })]);
  };
} }), be = A({ name: "TabList", props: { as: { type: [Object, String], default: "div" } }, setup(e, { attrs: c, slots: f }) {
  let y = D("TabList");
  return () => {
    let b = { selectedIndex: y.selectedIndex.value }, s = { role: "tablist", "aria-orientation": y.orientation.value };
    return B({ ourProps: s, theirProps: e, slot: b, attrs: c, slots: f, name: "TabList" });
  };
} }), me = A({ name: "Tab", props: { as: { type: [Object, String], default: "button" }, disabled: { type: [Boolean], default: !1 }, id: { type: String, default: null } }, setup(e, { attrs: c, slots: f, expose: y }) {
  var b;
  let s = (b = e.id) != null ? b : `headlessui-tabs-tab-${q()}`, l = D("Tab"), n = S(null);
  y({ el: n, $el: n }), N(() => l.registerTab(n)), W(() => l.unregisterTab(n));
  let m = j(C), w = p(() => {
    if (m.value) {
      let t = m.value.tabs.indexOf(s);
      return t === -1 ? m.value.tabs.push(s) - 1 : t;
    }
    return -1;
  }), h = p(() => {
    let t = l.tabs.value.indexOf(n);
    return t === -1 ? w.value : t;
  }), u = p(() => h.value === l.selectedIndex.value);
  function v(t) {
    var i;
    let x = t();
    if (x === F.Success && l.activation.value === "auto") {
      let I = (i = Z(n)) == null ? void 0 : i.activeElement, P = l.tabs.value.findIndex((R) => d(R) === I);
      P !== -1 && l.setSelectedIndex(P);
    }
    return x;
  }
  function O(t) {
    let i = l.tabs.value.map((x) => d(x)).filter(Boolean);
    if (t.key === T.Space || t.key === T.Enter) {
      t.preventDefault(), t.stopPropagation(), l.setSelectedIndex(h.value);
      return;
    }
    switch (t.key) {
      case T.Home:
      case T.PageUp:
        return t.preventDefault(), t.stopPropagation(), v(() => E(i, g.First));
      case T.End:
      case T.PageDown:
        return t.preventDefault(), t.stopPropagation(), v(() => E(i, g.Last));
    }
    if (v(() => L(l.orientation.value, { vertical() {
      return t.key === T.ArrowUp ? E(i, g.Previous | g.WrapAround) : t.key === T.ArrowDown ? E(i, g.Next | g.WrapAround) : F.Error;
    }, horizontal() {
      return t.key === T.ArrowLeft ? E(i, g.Previous | g.WrapAround) : t.key === T.ArrowRight ? E(i, g.Next | g.WrapAround) : F.Error;
    } })) === F.Success) return t.preventDefault();
  }
  let $ = S(!1);
  function a() {
    var t;
    $.value || ($.value = !0, !e.disabled && ((t = d(n)) == null || t.focus({ preventScroll: !0 }), l.setSelectedIndex(h.value), Y(() => {
      $.value = !1;
    })));
  }
  function r(t) {
    t.preventDefault();
  }
  let o = Q(p(() => ({ as: e.as, type: c.type })), n);
  return () => {
    var t, i;
    let x = { selected: u.value, disabled: (t = e.disabled) != null ? t : !1 }, { ...I } = e, P = { ref: n, onKeydown: O, onMousedown: r, onClick: a, id: s, role: "tab", type: o.value, "aria-controls": (i = d(l.panels.value[h.value])) == null ? void 0 : i.id, "aria-selected": u.value, tabIndex: u.value ? 0 : -1, disabled: e.disabled ? !0 : void 0 };
    return B({ ourProps: P, theirProps: I, slot: x, attrs: c, slots: f, name: "Tab" });
  };
} }), xe = A({ name: "TabPanels", props: { as: { type: [Object, String], default: "div" } }, setup(e, { slots: c, attrs: f }) {
  let y = D("TabPanels");
  return () => {
    let b = { selectedIndex: y.selectedIndex.value };
    return B({ theirProps: e, ourProps: {}, slot: b, attrs: f, slots: c, name: "TabPanels" });
  };
} }), Ie = A({ name: "TabPanel", props: { as: { type: [Object, String], default: "div" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, id: { type: String, default: null }, tabIndex: { type: Number, default: 0 } }, setup(e, { attrs: c, slots: f, expose: y }) {
  var b;
  let s = (b = e.id) != null ? b : `headlessui-tabs-panel-${q()}`, l = D("TabPanel"), n = S(null);
  y({ el: n, $el: n }), N(() => l.registerPanel(n)), W(() => l.unregisterPanel(n));
  let m = j(C), w = p(() => {
    if (m.value) {
      let v = m.value.panels.indexOf(s);
      return v === -1 ? m.value.panels.push(s) - 1 : v;
    }
    return -1;
  }), h = p(() => {
    let v = l.panels.value.indexOf(n);
    return v === -1 ? w.value : v;
  }), u = p(() => h.value === l.selectedIndex.value);
  return () => {
    var v;
    let O = { selected: u.value }, { tabIndex: $, ...a } = e, r = { ref: n, id: s, role: "tabpanel", "aria-labelledby": (v = d(l.tabs.value[h.value])) == null ? void 0 : v.id, tabIndex: u.value ? $ : -1 };
    return !u.value && e.unmount && !e.static ? G(X, { as: "span", "aria-hidden": !0, ...r }) : B({ ourProps: r, theirProps: a, slot: O, attrs: c, slots: f, features: U.Static | U.RenderStrategy, visible: u.value, name: "TabPanel" });
  };
} });
export {
  me as Tab,
  fe as TabGroup,
  be as TabList,
  Ie as TabPanel,
  xe as TabPanels
};
